import { format, formatDistanceStrict, isValid, parseISO } from 'date-fns';

/**
 * Timestamp rendering.
 *
 * Every date crosses the wire as an ISO 8601 string, never a `Date`, so parsing
 * is the caller's job and belongs in exactly one place. Cards show the relative
 * form ("2 days ago") because a reviewer cares about recency, and carry the
 * absolute form in a tooltip because "2 days ago" is useless in a bug report.
 *
 * `now` is a parameter rather than a call to `Date.now()` inside so the
 * behaviour is testable without freezing the clock.
 */

/** Shown instead of a date when a timestamp cannot be parsed. */
const UNKNOWN = 'unknown';

/** "3 minutes ago", "2 days ago", "in 5 minutes" for a clock skewed forward. */
export const formatRelativeTime = (
  iso: string,
  now: Date = new Date(),
): string => {
  const date = parseISO(iso);

  if (!isValid(date)) {
    return UNKNOWN;
  }

  return formatDistanceStrict(date, now, { addSuffix: true });
};

/** "14 Mar 2026, 09:41" — unambiguous, for tooltips and title attributes. */
export const formatAbsoluteTime = (iso: string): string => {
  const date = parseISO(iso);

  if (!isValid(date)) {
    return UNKNOWN;
  }

  return format(date, 'd MMM yyyy, HH:mm');
};
